<mat-searchable-select [formControl]="formControl" (changed)="selectedItem = $event.nextValue">
  <mat-searchable-select-label>Lorem Words</mat-searchable-select-label>
  <mat-searchable-select-search-label>Search</mat-searchable-select-search-label>
  <mat-searchable-select-list [options]="options">
    <ng-template matSearchableSelectOption
                 let-option="option">
      {{option}}
    </ng-template>
  </mat-searchable-select-list>
</mat-searchable-select>
<ng-container *ngIf="selectedItem">
  <p>Selected Item</p><code>{{selectedItem}}</code>
</ng-container>
<ng-container *ngIf="formControl.value">
  <p>Form Control Value</p><code>{{formControl.value}}</code>
</ng-container>
